import { Controller } from "@hotwired/stimulus"

// Cmd/Ctrl+Enter submits the chat message form. Plain Enter still inserts
// a newline (default textarea behavior). Wired via data-action on the
// textarea in app/views/messages/_form.html.erb.
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.element.requestSubmit()
  }
}
